import React, { useState } from "react";
import HeroSection from "./HeroSection";
import { Footer, FloatingChatButton } from "../common";
import "../../styles/landing.css";

const HomeNonAuth = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  return (
    <div className="landing-page">
      {/* ✅ Header is handled globally by AppLayout */}
      <HeroSection
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
      />
      <Footer />
      {/* <FloatingChatButton /> */}
    </div>
  );
};

export default HomeNonAuth;